export default "__VITE_ASSET__e8b2bd9b__"